import { GlobalActionConstants } from "../action-constants";

const { INIT_STATE, UPDATE_STATE } = GlobalActionConstants;

const globalReducerHelper = (state, type, data, emptyState) => {
  if (!state) {
    return {};
  }
  if (!type || !data) return state;

  switch (type) {
    case INIT_STATE:
      return { ...emptyState, ...data };
    case UPDATE_STATE:
      return { ...state, ...data };
    default:
      return state;
  }
};

export default globalReducerHelper;
